import React, { Component } from "react";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
//Import Breadcrumb

import classnames from "classnames";

class Tabs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTabJustify: this.props.defaultTab,
        };
        this.toggle = this.toggle.bind(this);

        this.toggleCustomJustified = this.toggleCustomJustified.bind(this);
    }

    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
        this.props.getActiveTab(tab)
    }

    toggleCustomJustified(tab) {
        if (this.state.activeTabJustify !== tab) {
            this.setState({
                activeTabJustify: tab
            });
        }
        this.props.getActiveTab(tab)
    }

    render() {
        const { content } = this.props
        const activeTabJustify = this.props.activeTab ?? this.state.activeTabJustify
        return (
            <React.Fragment>
                <Nav
                    tabs
                    className="nav-tabs-custom d-flex flex-row flex-nowrap overflow-auto"
                    style={{
                        paddingBottom: "2px",
                        border: "none",
                        overflowX: "auto",
                        scrollbarWidth: "thin", // For Firefox
                        scrollbarColor: "#888 #f1f1f1", // For Firefox (thumb color, track color)
                    }}
                >
                    {
                        content?.length > 0 && content.map((x, idx) => (
                            <NavItem key={idx}>
                                <NavLink
                                    key={`idx+ ${idx}`}
                                    style={{ cursor: "pointer", whiteSpace: "nowrap" }}  // Prevents text wrapping
                                    className={x.tabID === activeTabJustify ? classnames({ active: true }) : ""}
                                    onClick={() => this.toggleCustomJustified(x.tabID)}
                                >
                                    <span className="d-sm-block">{x.header} <span style={{ backgroundColor: "#F5FCFF", color: "#127099", width: "50px", borderRadius: "8px" }}>{x?.count}</span></span>
                                </NavLink>
                            </NavItem>
                        ))
                    }
                </Nav>

                <TabContent activeTab={activeTabJustify} >
                    {
                        content !== "" && content.length > 0 && content.map((x, idx) => {
                            return (
                                x.tabID === activeTabJustify &&
                                <TabPane tabId={x.tabID} key={idx}>
                                    {x.children}
                                </TabPane>


                            )
                        }
                        )
                    }
                </TabContent>
            </React.Fragment>
        );
    }
}

export default Tabs;
